import { useMemo, useCallback } from "react"
import { useGetList } from "venue-react"
import { ImdfFeature, Model3d, Model3dData } from "../../../types"
import { prepareModel3dData } from "./utils/prepareModel3dData"
import { useGetImdf } from "../useGetImdf"
export const useGetModel3ds = () => {
  const { data: imdfData } = useGetImdf()
  const findOne = useCallback(
    <T = ImdfFeature>(id) => imdfData.features.find((f) => f.id === id) as T,
    [imdfData]
  )
  const { data: rawModel3ds = [] } = useGetList(
    "model3d",
    {},
    { refetchOnWindowFocus: false }
  )
  const data = useMemo<Model3dData[]>(
    () =>
      (rawModel3ds as unknown as Model3d[]).map((model3d) =>
        prepareModel3dData(model3d, findOne)
      ),
    [rawModel3ds, findOne]
  )
  return { data }
}
